module.exports = __webpack_public_path__ + "media/components/assets/img/icons/bulb-green-7889fa78b235e7e5c7f123915438cd48.svg";